<template>
  <div>
    <div class="tui-card">
      <el-tabs type="border-card" v-model="current" @tab-click="onClickTable">
        <el-tab-pane
          :label="item"
          v-for="(item, index) in tabList"
          :key="index"
        >
          <template v-if="Number(current) == index">
            <div
              class="tui-student"
              style="margin-bottom: 20px"
              @click="onClickLook(0)"
            >
              <div class="tui-studentBox">
                <div class="tui-studentItem">
                  <div class="flex-items">{{ totalInfo.Time }}</div>
                  <div class="introduce">总时长</div>
                </div>
                <div class="tui-studentItem">
                  <div class="flex-items">{{ totalInfo.Score }}</div>
                  <div class="introduce">总得分</div>
                </div>
                <div class="tui-studentItem">
                  <div class="flex-items">{{ myInfo.Time }}</div>
                  <div class="introduce">我的时长</div>
                </div>
                <div class="tui-studentItem">
                  <div class="flex-items">{{ myInfo.Score }}</div>
                  <div class="introduce">我的分数</div>
                </div>
              </div>
            </div>
            <el-select
              v-model="value"
              placeholder="请选择实践活动"
              style="margin-right: 20px"
              @change="onChangeActivity"
            >
              <el-option
                v-for="item in PostList"
                :key="item.Id"
                :label="item.Name"
                :value="item.Id"
              >
              </el-option>
            </el-select>
            <el-select
              v-model="Score"
              placeholder="请选择分数/时长"
              @change="onChangeScore"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.text"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <el-table
              :data="tableData"
              border
              style="width: 100%; margin-top: 20px"
            >
              <el-table-column label="序号" width="50" align="center">
                <template slot-scope="scope">
                  {{ scope.$index + (PageIndex - 1) * PageSize + 1 }}
                </template>
              </el-table-column>
              <el-table-column prop="Name" label="姓名" align="center">
              </el-table-column>
              <el-table-column prop="Score" label="分数" align="center">
              </el-table-column>
              <el-table-column prop="Time" label="时长" align="center">
              </el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    @click="onClickLook(scope.row.StudentId)"
                    >查看</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="PageIndex"
              :page-sizes="[10, 20, 30, 40]"
              :page-size="PageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
              style="text-align: center; padding: 20px 0 0 0"
            >
            </el-pagination>
          </template>
        </el-tab-pane>
      </el-tabs>
    </div>
    <el-dialog title="查看分数明细" :visible.sync="dialogVisible" width="30%">
      <div>
        <div class="tui-list" v-for="(item, index) in popupData" :key="index">
          <div class="left">
            <img
              class="img"
              src="https://qinghesuyang.oss-cn-shanghai.aliyuncs.com/resource/2023-12/2023-12-28/202312281859292.png"
              alt=""
            />
            <div class="left-down">
              <div class="name">{{ item.StudentName }}</div>
              <div class="desc">
                {{ `分数：${item.Score} 时长：${item.Time}` }}
              </div>
            </div>
          </div>
          <div class="right">{{ item.PostName }}</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  GetTotalEPInfo,
  Get_PostSelectInfo,
  GetEPScoreDetailInfo,
} from "../../api/api";
export default {
  data() {
    return {
      tabList: ["校内实践", "校外实践"],
      current: "0",
      options: [
        {
          text: "分数",
          value: 1,
        },
        {
          text: "时长",
          value: 2,
        },
      ],
      Score: 1,
      PostList: [],
      value: "",
      PageIndex: 1,
      PageSize: 10,
      tableData: [],
      total: 0,
      myInfo: {},
      totalInfo: {},
      StudentId: 0,
      dialogVisible: false,
      popupData: [],
    };
  },
  async created() {
    await this.Get_PostSelectInfo();
    await this.GetTotalEPInfo();
  },
  methods: {
    async GetEPScoreDetailInfo() {
      let res = await GetEPScoreDetailInfo({
        EP_PostId: this.value == "" ? 0 : this.value,
        PostEnumType: this.current == "0" ? 2 : 3,
        Type: this.Score,
        StudentId: this.StudentId,
        PageIndex: 1,
        PageSize: 100000,
        Name: "",
      });
      if (res.data.success) {
        this.popupData = res.data.response;
      } else {
        this.popupData = [];
      }
    },
    onClickLook(StudentId) {
      this.StudentId = StudentId;
      this.GetEPScoreDetailInfo();
      this.dialogVisible = true;
    },
    onClickTable(e) {
      this.current = e.index;
      this.GetTotalEPInfo();
    },
    onChangeActivity(e) {
      this.value = e;
      this.GetTotalEPInfo();
    },
    onChangeScore(e) {
      this.Score = e;
      this.GetTotalEPInfo();
    },
    handleCurrentChange(val) {
      this.PageIndex = val;
      this.GetTotalEPInfo();
    },
    handleSizeChange(val) {
      this.PageSize = val;
      this.GetTotalEPInfo();
    },
    async Get_PostSelectInfo() {
      let res = await Get_PostSelectInfo({
        Id: 0,
      });
      if (res.data.success) {
        this.PostList = res.data.response;
      }
    },
    async GetTotalEPInfo() {
      let res = await GetTotalEPInfo({
        EP_PostId: this.value == "" ? 0 : this.value,
        PostEnumType: this.current == "0" ? 2 : 3,
        Type: this.Score,
        PageIndex: this.PageIndex,
        PageSize: this.PageSize,
        Name: "",
        StudentId: 0,
      });
      if (res.data.success) {
        this.myInfo = res.data.response.myInfo;
        this.totalInfo = res.data.response.totalInfo;
        this.tableData = res.data.response.pageInfo.data;
        this.total = res.data.response.pageInfo.dataCount;
      } else {
        this.tableData = [];
        this.total = 0;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.tui-list {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 30px;
  box-sizing: border-box;
  .left {
    display: flex;
    align-items: center;
    .left-down {
      display: flex;
      flex-direction: column;
    }
    .img {
      width: 40px;
      height: 40px;
    }
    .name {
      color: #3b4144;
      font-size: 16px;
    }
    .desc {
      color: #999;
      font-size: 16px;
      display: flex;
      align-items: center;
    }
  }
  .right {
    color: #999;
    font-size: 16px;
  }
}
.tui-student {
  width: 100%;
  height: 100px;
  background: #f8f8f8;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  .tui-studentTitle {
    font-size: 18px;
    color: #333333;
    font-family: Font;
    padding: 15px;
  }

  .tui-studentBox {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-around;

    .tui-studentItem {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      font-size: 20px;
      color: #333;
      font-family: Bood;

      .btn {
        width: 81px;
        height: 34px;
        background: rgba(247, 181, 0, 0.08);
        border-radius: 4px;
        border: 1px solid #f7b500;
        font-size: 20px;
        color: #f7b500;
        font-family: Font;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .introduce {
        font-size: 16px;
        color: #999;
        font-family: Font;
        padding-top: 14px;
      }

      span {
        font-size: 18px;
        color: #333;
        font-family: Font;
        padding: 0 tovmin(5);
      }

      img {
        width: 22px;
        height: 22px;
      }
    }
  }
}
.tui-card {
  padding: 30px;
  box-sizing: border-box;
}
</style>
